/**
 * Boot payload the EJS shell serialises into `window.__FG_BOOT__`. The SPA reads
 * this once at mount, then immediately fires `/api/customer/context` to upgrade
 * to a freshly signed CSRF token + (for anon users) a guaranteed cookie roundtrip.
 *
 * When the SPA runs under the Vite dev server (port 5173) there is no EJS shell,
 * so `window.__FG_BOOT__` is undefined and the SPA boots in pure-anon mode until
 * the context ping replies.
 */
/**
 * Mirror of the server's `PreviewGatePayload` (src/lib/renderCustomerSpaShell.ts).
 * Present in the boot only when the proxy gate refused this request; its
 * presence flips the SPA into the React preview-gate screen (inside theme
 * chrome) and tells `AuthProvider` to skip the `/api/customer/context` ping.
 */
export type PreviewGatePayload = {
  loginUrl: string;
  codeForm: {
    action: string;
    returnTo: string;
    error: boolean;
  } | null;
};

export type BootPayload = {
  auth: "customer" | "anon";
  // Only the id arrives via the boot shell; firstName/email and the rest come from
  // /api/customer/context (see AuthProvider), never the inline boot script.
  customer?: { id: string };
  shop?: { domain: string };
  featureFlags?: Record<string, boolean>;
  previewGate?: PreviewGatePayload;
};

declare global {
  interface Window {
    __FG_BOOT__?: BootPayload;
  }
}

export function readBoot(): BootPayload {
  return window.__FG_BOOT__ ?? { auth: "anon" };
}
